import { render, staticRenderFns } from "./DiasMaisFrequentesCard.vue?vue&type=template&id=10523031"
import script from "./DiasMaisFrequentesCard.vue?vue&type=script&lang=js"
export * from "./DiasMaisFrequentesCard.vue?vue&type=script&lang=js"
import style0 from "./DiasMaisFrequentesCard.vue?vue&type=style&index=0&id=10523031&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports